import React, { createContext, useContext, useState } from 'react';

const TimezoneContext = createContext();

export const TimezoneProvider = ({ children }) => {
  const [timezoneConfig, setTimezoneConfig] = useState({
    disabled: false,
    forceValue: null,
    label: null,
  });

  const setTimezoneFixed = (forceValue = 'Etc/GMT', label = 'Timezone (Fixed):') => {
    setTimezoneConfig({
      disabled: true,
      forceValue,
      label,
    });
  };

  const setTimezoneNormal = () => {
    setTimezoneConfig({
      disabled: false,
      forceValue: null,
      label: null,
    });
  };

  return (
    <TimezoneContext.Provider
      value={{
        timezoneConfig,
        setTimezoneFixed,
        setTimezoneNormal,
      }}
    >
      {children}
    </TimezoneContext.Provider>
  );
};

export const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (!context) {
    throw new Error('useTimezone must be used within TimezoneProvider');
  }
  return context;
};
